var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Bar',{attrs:{"label":_vm.label,"data":_vm.scores,"labels":_vm.playernames}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }